var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 1,
    height: 18,
    fill: "#74A3C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7,
    width: 1,
    height: 18,
    fill: "#74A3C7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 7,
    width: 1,
    height: 18,
    fill: "#74A3C7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 3,
    height: 3,
    fill: "#74A3C7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 3,
    height: 3,
    fill: "#74A3C7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 20,
    width: 3,
    height: 3,
    fill: "#74A3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimits);
export default __webpack_public_path__ + "static/media/limits.fff95e913a44c8cfcaf2c12e0006b8e4.svg";
export { ForwardRef as ReactComponent };